export default {
  path: "/classroomUsage",
  name: "classroomUsage",
  redirect: "/classroomUsage/list",
  meta: {
    title: "教室使用情况",
    showMainMenu: false
  },
  children: [
    {
      path: "/classroomUsage/list",
      name: "classroomUsageList",
      component: () =>
        import(
          /* webpackChunkName: "classroomUsage" */ "@/views/classroomUsage/List.vue"
        ),
      meta: {
        title: "教室使用情况",
        showMainMenu: true,
        icon: "icon-chat"
      }
    },
    {
      path: "/classroomUsage/detail",
      name: "classroomUsageDetail",
      component: () =>
        import(
          /* webpackChunkName: "classroomUsage" */ "@/views/classroomUsage/Detail.vue"
        ),
      meta: {
        title: "教室使用情况",
        // showMainMenu: true,
        icon: "icon-chat"
      }
    },
    {
      path: "/classroomUsage/classroomList",
      name: "classroomUsageClassroomList",
      component: () =>
        import(
          /* webpackChunkName: "classroomUsage" */ "@/views/classroomUsage/ClassRoomList.vue"
        ),
      meta: {
        title: "教室名称",
        // showMainMenu: true,
        icon: "icon-chat"
      }
    }
  ]
};
